export { WidgetIcon } from './WidgetIcon';
export type { WidgetIconProps } from './WidgetIcon';
